import { DROPDOWN_PORTAL_ID } from '@/navbarElement';
import type { NavbarMenuElementProps } from '@/navbarElement/Navbar.type';
import { cn, getBackgroundColor } from '@/utils';
import type { CSSProperties } from 'react';
import { NAVBAR_MENU_DEFAULTS } from '../../navbarElement/NavbarMenu.constants';
import * as styles from '../Navbar.css';

const DEFAULT_BOX_SHADOW = '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)';

export function NavbarMenuV2(props: NavbarMenuElementProps) {
  const { element, children, className, attributes, screen } = props;
  const {
    background,
    shadow,
    style,
    customAttributes,
    gap,
    borderWidth,
    borderStyle,
    borderColor,
    stickToTop,
    borderRadius,
    blurBackground,
  } = element.attrs || {};

  const boxShadow = style === 'shadow' ? DEFAULT_BOX_SHADOW : shadow;

  const borderStyles = {
    borderColor: borderColor ?? NAVBAR_MENU_DEFAULTS.borderBorderColor,
    borderWidth: borderWidth ?? NAVBAR_MENU_DEFAULTS.borderBorderWidth,
    borderStyle: borderStyle ?? NAVBAR_MENU_DEFAULTS.borderBorderStyle,
  };

  return (
    <nav
      {...props}
      defaultValue="221"
      role="presentation"
      {...customAttributes}
      className={cn(
        className,
        customAttributes?.className,
        styles.navbarMenuV2,
        stickToTop ? styles.navbarMenuStickyV2 : styles.navigationMenuRelativeV2,
        styles.navbarMenuDefaultBackgroundV2,
        // blurBackground ? styles.navbarMenuBlurBackground : styles.navbarMenuDefaultBackground, PUNTING THIS FOR NOW
      )}
      style={
        {
          width: '100%',
          gap: gap ?? NAVBAR_MENU_DEFAULTS.gap,
          ...borderStyles,
          '--box-shadow': boxShadow,
          // '--gap': gap ?? NAVBAR_MENU_DEFAULTS.gap, // todo: in navbar_v1, it is not possible to set gap between rows, and this is overridden by children
          '--background': getBackgroundColor(background ?? NAVBAR_MENU_DEFAULTS.background),
          '--border-radius': borderRadius ?? NAVBAR_MENU_DEFAULTS.borderRadius,
          flexDirection: 'column',
          '--blur-background': blurBackground ?? NAVBAR_MENU_DEFAULTS.blurBackground,
        } as CSSProperties
      }
      {...attributes}
    >
      <div id={`${DROPDOWN_PORTAL_ID}-${screen}`} className={styles.navbarMenuDropdownPortalV2} data-sticky="true" />
      {children}
    </nav>
  );
}
